"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WildlifeDome = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const constants_1 = require("../../constants");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const TurmoilHandler_1 = require("../../turmoil/TurmoilHandler");
const Turmoil_1 = require("../../turmoil/Turmoil");
const TileType_1 = require("../../TileType");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class WildlifeDome extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.WILDLIFE_DOME,
            cost: 15,
            tags: [Tags_1.Tags.ANIMAL, Tags_1.Tags.PLANT, Tags_1.Tags.BUILDING],
            cardType: CardType_1.CardType.AUTOMATED,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.GREENS)),
            tr: { oxygen: 1 },
            metadata: {
                cardNumber: 'T15',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.greenery();
                }),
                description: 'Requires that Greens are ruling or that you have 2 delegates there. Place a greenery tile and raise oxygen 1 step.',
            },
        });
    }
    canPlay(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        const canPlaceTile = player.game.board.getAvailableSpacesForGreenery(player).length > 0;
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (turmoil === undefined)
            return false;
        if (!canPlaceTile)
            return false;
        let canAffordReds = true;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, true, false, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            canAffordReds = this.howToAffordReds.canAfford;
        }
        else {
            this.howToAffordReds = undefined;
        }
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.GREENS)) {
            const meetsPartyRequirements = turmoil.canPlay(player, PartyName_1.PartyName.GREENS);
            const oxygenMaxed = player.game.getOxygenLevel() === constants_1.MAX_OXYGEN_LEVEL;
            if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS) && !oxygenMaxed) {
                return meetsPartyRequirements && canAffordReds;
            }
            return meetsPartyRequirements;
        }
        let societyCost = player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST;
        if (this.reserveUnits.megacredits > 0)
            societyCost += this.reserveUnits.megacredits;
        Card_1.Card.setSocietyWarningText(this, PartyName_1.PartyName.GREENS);
        return player.canAfford(societyCost);
    }
    play(player) {
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => new SelectSpace_1.SelectSpace('Select space for greenery tile', player.game.board.getAvailableSpacesForGreenery(player), TileType_1.TileType.GREENERY, (space) => {
            return player.game.addGreenery(player, space.id);
        })));
        TurmoilHandler_1.TurmoilHandler.handleSocietyPayment(player, PartyName_1.PartyName.GREENS);
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromOxygenIncrease(1) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({
            card: card,
            oxygenIncrease: 1,
            nonOceanToPlace: TileType_1.TileType.GREENERY,
            nonOceanAvailableSpaces: player.game.board.getAvailableSpacesForGreenery(player),
            bonusMegaCredits: bonusMegaCredits,
        });
    }
}
exports.WildlifeDome = WildlifeDome;
//# sourceMappingURL=WildlifeDome.js.map